/* ===========================
   Fabric Love – Offer Modal (full file)
   - Safari-safe Omnisend preload
   - Google 5-page gate (reads sessionStorage fl_google_gate)
   - Member persistence: 10 days via localStorage fl_member_persist_ts
   - Applies ALL active member codes: window.FL_ACTIVE_MEMBER_CODES
   - Optional tracking: dataLayer events (safe no-op if unused)
   =========================== */

const FL_ACTIVE_MEMBER_CODES = window.FL_ACTIVE_MEMBER_CODES || [];

/* ---------- Storage helpers ---------- */
function ssGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
function ssSet(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

function lsGet(key){ try{return localStorage.getItem(key);}catch(e){return null;} }
function lsSet(key,val){ try{localStorage.setItem(key,val);}catch(e){} }

function memberPersistValid(){
  const ts = parseInt(lsGet('fl_member_persist_ts'), 10);
  if (!ts) return false;
  const TEN_DAYS = 10 * 24 * 60 * 60 * 1000;
  return (Date.now() - ts) < TEN_DAYS;
}

/* ---------- Optional tracking (safe) ---------- */
function flTrack(eventName, params){
  try {
    params = params || {};

    // 1) Send to GA4 directly (Shopify GA4 uses gtag)
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    // 2) Also push to dataLayer for debugging / GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });

  } catch(e){}
}



(function () {
  if (
  location.search.toLowerCase().includes('utm_source=omnisend') &&
  location.search.toLowerCase().includes('utm_campaign=campaign')
) {
  ssSet('fl_member_session', '1');
  applyAllDiscounts(); // <-- add this
}

  function norm(s) { return (s || '').toString().trim().toUpperCase(); }

  function keySubmitted(offerKey, code) {
    return `fl_offer_${norm(offerKey)}_submitted_${norm(code)}`;
  }
  function keyApplied(offerKey, code) {
    return `fl_offer_${norm(offerKey)}_applied_${norm(code)}`;
  }

  /* ---------- Cart UI refresh ---------- */
  function refreshCartUI() {
    try {
      document.dispatchEvent(new Event('cart:refresh'));
      document.dispatchEvent(new Event('cart:updated'));
      document.dispatchEvent(new Event('cart:change'));

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(() => { document.dispatchEvent(new Event('cart:updated')); });
    } catch(e){}
  }

  /* ---------- Apply all member discounts ---------- */
  async function applyAllDiscounts() {
    if (!FL_ACTIVE_MEMBER_CODES.length) return;

    const appliedKey = 'fl_global_discounts_applied';
    if (ssGet(appliedKey) === '1') return;

    for (const rawCode of FL_ACTIVE_MEMBER_CODES) {
      const code = norm(rawCode);
      if (!code) continue;

      try {
        const url = `/discount/${encodeURIComponent(code)}?redirect=/`;
        await fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store'
        });

        // Allow Shopify to persist each code
        await new Promise(r => setTimeout(r, 250));
      } catch (e) {
        console.error('[FL offer] Failed to apply', code, e);
      }
    }

    ssSet(appliedKey, '1');

    // Refresh cart UI once after all codes applied
    setTimeout(refreshCartUI, 400);
  }

  /* ---------- DOM helpers ---------- */

  async function ensureMemberDiscountsIfPersisted() {
  try {
    // only for returning members (10-day persist)
    if (!memberPersistValid()) return;

    // mark as member for THIS session (so all blocks show success)
    if (ssGet('fl_member_session') !== '1') {
      ssSet('fl_member_session', '1');
    }

    // apply all discounts once per session (applyAllDiscounts already guards)
    await applyAllDiscounts();

    // refresh cart UI so drawer/totals reflect it
    setTimeout(refreshCartUI, 400);
  } catch (e) {}
}

  function bits(wrap) {
    return {
      teaser: wrap.querySelector('[data-fl-offer-teaser]'),
      image: wrap.querySelector('.fl-offer-image'),
      formWrap: wrap.querySelector('[data-fl-offer-form]'),
      appliedMsg: wrap.querySelector('[data-fl-offer-applied]')
    };
  }

  function getOmnisendHolder(wrap) {
    if (!wrap) return null;
    const id = wrap.getAttribute('data-omnisend-id');
    if (id) return document.getElementById(id);
    return wrap.querySelector('[id^="omnisend-embedded-v2-"]');
  }

  function isEmbedReady(wrap) {
    const holder = getOmnisendHolder(wrap);
    if (!holder) return false;
    return (holder.children && holder.children.length > 0) || (holder.childNodes && holder.childNodes.length > 0);
  }

  function waitForEmbedReady(wrap, timeoutMs) {
    timeoutMs = typeof timeoutMs === 'number' ? timeoutMs : 12000;

    return new Promise(function (resolve) {
      if (!wrap) return resolve(false);
      if (wrap.__flOmniReady === true) return resolve(true);

      if (isEmbedReady(wrap)) {
        wrap.__flOmniReady = true;
        return resolve(true);
      }

      const holder = getOmnisendHolder(wrap);
      if (!holder) return resolve(false);

      let done = false;
      const start = Date.now();

      function finish(ok) {
        if (done) return;
        done = true;
        try { obs && obs.disconnect(); } catch (e) {}
        wrap.__flOmniReady = !!ok;
        resolve(!!ok);
      }

      let obs = null;
      try {
        obs = new MutationObserver(function () {
          if (isEmbedReady(wrap)) finish(true);
          if (Date.now() - start > timeoutMs) finish(false);
        });
        obs.observe(holder, { childList: true, subtree: true });
      } catch (e) {
        const t = setInterval(function () {
          if (isEmbedReady(wrap)) { clearInterval(t); finish(true); }
          if (Date.now() - start > timeoutMs) { clearInterval(t); finish(false); }
        }, 150);
      }

      setTimeout(function () {
        finish(isEmbedReady(wrap));
      }, timeoutMs);
    });
  }

  const modal = () => document.getElementById('fl-offer-modal');
  const modalContent = () => document.getElementById('fl-offer-modal-content');

  function rememberOriginalParent(formEl) {
    if (!formEl || formEl.__flOriginalParent) return;
    formEl.__flOriginalParent = formEl.parentElement;
    formEl.__flOriginalNext = formEl.nextElementSibling;
  }

  function restoreFormToOriginalPlace(formEl) {
    if (!formEl || !formEl.__flOriginalParent) return;
    const parent = formEl.__flOriginalParent;
    const next = formEl.__flOriginalNext;
    if (next && next.parentElement === parent) parent.insertBefore(formEl, next);
    else parent.appendChild(formEl);
  }

  function setDefaultUI(wrap) {
    const { teaser, image, appliedMsg } = bits(wrap);
    if (teaser) teaser.classList.remove('is-hidden');
    if (image) image.classList.remove('is-hidden');
    if (appliedMsg) appliedMsg.classList.remove('is-on');
    wrap.setAttribute('data-fl-active', '0');
  }

  function setSubmittedUI(wrap) {
    const { teaser, image, appliedMsg } = bits(wrap);
    if (teaser) teaser.classList.add('is-hidden');
    if (image) image.classList.add('is-hidden');
    if (appliedMsg) appliedMsg.classList.add('is-on');
    wrap.setAttribute('data-fl-active', '0');
  }

  function fireImpressionOnce(wrap) {
    const code = wrap.getAttribute('data-discount-code') || '';
    if (!code) return;

    const impKey = 'fl_offer_imp_' + code + '_' + location.pathname;
    if (ssGet(impKey) === '1') return;

    ssSet(impKey, '1');
    flTrack('fl_member_offer_impression', {
      offer_code: code,
      page_path: location.pathname
    });
  }

function initOffers() {
  document.querySelectorAll('[data-fl-offer]').forEach(function (wrap) {
    const offerKey = wrap.getAttribute('data-offer-key') || 'offer';
    const code = wrap.getAttribute('data-discount-code') || '';
    if (!code) return;

    const root = wrap.closest('.fl-offer-root') || wrap;

    // 1) Member (session OR persisted) overrides everything
    if (ssGet('fl_member_session') === '1' || memberPersistValid()) {
      root.style.display = 'block';
      setSubmittedUI(wrap);
      return;
    }

    // 2) Google gate hides entire block
    if (ssGet('fl_google_gate') === '1') {
      root.style.display = 'none';
      return;
    }

    // 3) Normal per-offer logic
    root.style.display = 'block';

    const submittedKey = keySubmitted(offerKey, code);

    if (ssGet(submittedKey) === '1') {
      setSubmittedUI(wrap);
    } else {
      setDefaultUI(wrap);
      fireImpressionOnce(wrap); // only fire when signup/teaser state is actually shown
    }

    // Kick preload watcher (helps iOS be ready before first click)
    waitForEmbedReady(wrap, 12000);
  });
}

  function hasOmnisendReachedSuccessWithForm(formWrapEl) {
    if (!formWrapEl) return false;

    const success = formWrapEl.querySelector('[class*="success-sections-container"]');
    const subscribed = formWrapEl.querySelector('[class*="subscribed-sections-container"]');

    function isShown(el) {
      if (!el) return false;
      const cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
    }

    return isShown(success) || isShown(subscribed);
  }

  function getActiveWrap() {
    return document.querySelector('[data-fl-offer][data-fl-active="1"]');
  }

  let pollTimer = null;
  function stopPolling() { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }

  async function handleIfSuccessNow() {
    const wrap = getActiveWrap();
    if (!wrap) return;

    const offerKey = wrap.getAttribute('data-offer-key') || 'offer';
    const code = wrap.getAttribute('data-discount-code') || '';
    if (!code) return;

    const formRef = wrap.__flFormWrapRef || null;
    if (!formRef) return;

    // Only proceed once Omnisend reached success/subscribed
    if (!hasOmnisendReachedSuccessWithForm(formRef)) return;

    // Prevent double-handling
    if (wrap.__flSuccessHandled) return;
    wrap.__flSuccessHandled = true;

    stopPolling();

    // Session-wide + persisted member flags (persist 10 days)
    ssSet('fl_member_session', '1');
    lsSet('fl_member_persist_ts', Date.now());

    flTrack('fl_member_offer_submit', {
      offer_code: code,
      page_path: location.pathname
    });

    const submittedKey = keySubmitted(offerKey, code);
    const appliedKey = keyApplied(offerKey, code);

    // Mark this offer as submitted (for per-offer UI state)
    ssSet(submittedKey, '1');

    // Apply all active member discounts once per offer (per session key)
    if (ssGet(appliedKey) !== '1') {
      try {
        await applyAllDiscounts();
        ssSet(appliedKey, '1');
      } catch (e) {
        console.error('[FL offer] Discount apply failed', e);
      }
    }

    // Re-init UI to reflect member success state
    initOffers();
  }

  function startPolling() {
    if (pollTimer) return;
    const start = Date.now();
    pollTimer = setInterval(async function () {
      if (Date.now() - start > 30000) { stopPolling(); return; }
      await handleIfSuccessNow();
    }, 250);
  }

  async function openModalWithForm(wrap) {
    const m = modal();
    const content = modalContent();
    if (!m || !content) return;

    stopPolling();

    const formWrap = bits(wrap).formWrap;
    if (!formWrap) return;

    // OPEN MODAL IMMEDIATELY
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fl-modal-open');

    flTrack('fl_member_offer_modal_open', {
      offer_code: wrap.getAttribute('data-discount-code') || '',
      page_path: location.pathname
    });

    // Mark active
    document.querySelectorAll('[data-fl-offer]').forEach(el => el.setAttribute('data-fl-active', '0'));
    wrap.setAttribute('data-fl-active', '1');

    // Loading UI
    content.innerHTML = '<div class="fl-offer-loading">Loading offer…</div>';

    // Wait for embed ready
    const ready = await waitForEmbedReady(wrap, 12000);

    // If closed while waiting, stop
    if (!m.classList.contains('is-open')) return;

    if (!ready) {
      content.innerHTML = '<div class="fl-offer-loading">The signup form is taking a moment to load. Please refresh and try again.</div>';
      return;
    }

    // Move form into modal
    wrap.__flSuccessHandled = false;
    rememberOriginalParent(formWrap);
    content.innerHTML = '';
    content.appendChild(formWrap);

    wrap.__flFormWrapRef = formWrap;
    formWrap.classList.add('is-open');

    // Nudge Safari reflow after move
    requestAnimationFrame(function () {
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    });
    setTimeout(function () {
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }, 150);

    startPolling();
  }

  function closeModal() {
    const m = modal();
    const content = modalContent();
    if (!m || !content) return;

    stopPolling();

    const activeWrap = getActiveWrap();

    const formWrap = content.querySelector('[data-fl-offer-form]');
    if (formWrap) {
      formWrap.classList.remove('is-open');
      restoreFormToOriginalPlace(formWrap);
    }

    content.innerHTML = '';
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fl-modal-open');

    document.querySelectorAll('[data-fl-offer]').forEach(el => el.setAttribute('data-fl-active', '0'));
    if (activeWrap) activeWrap.__flFormWrapRef = null;

    initOffers();
  }

  function wireModalCloseEvents() {
    const m = modal();
    if (!m || m.__flWired) return;
    m.__flWired = true;

    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-fl-modal-close]')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && m.classList.contains('is-open')) closeModal();
    });
  }

document.addEventListener('DOMContentLoaded', function () {
  wireModalCloseEvents();

  // If returning member (10-day persist), re-apply codes at start of session
  ensureMemberDiscountsIfPersisted().finally(function () {
    initOffers();
  });
});


  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-fl-offer-toggle]');
    if (!toggle) return;

    e.preventDefault();

    const wrap = toggle.closest('[data-fl-offer]');
    if (!wrap) return;

    const offerKey = wrap.getAttribute('data-offer-key') || 'offer';
    const code = wrap.getAttribute('data-discount-code') || '';
    if (!code) return;

    flTrack('fl_member_offer_click', {
      offer_code: code,
      page_path: location.pathname
    });

    const submittedKey = keySubmitted(offerKey, code);

    if (ssGet(submittedKey) === '1' || memberPersistValid() || ssGet('fl_member_session') === '1') {
      setSubmittedUI(wrap);
      return;
    }

    openModalWithForm(wrap);
  });

})();
